import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "src/utils/api";
import evaluateTriggerConditions from "src/utils/helper";

export const useSequenceStore = defineStore("sequence_store", {
  state: () => ({}),
  actions: {
    async getSequenceName(sequenceGroupID, conditionData) {
      const response = await Api.Sequence.getSequenceGroup(sequenceGroupID);
      if (response.data) {
        for (const sequence of response.data.sequences) {
          if (sequence.condition === true) {
            return sequence.seq_name;
          } else if (
            evaluateTriggerConditions(sequence.condition, conditionData)
          ) {
            return sequence.seq_name;
          }
        }
      }
      return null;
    },
    async getNextSequenceValue(sequenceName) {
      const response = await Api.Sequence.getNextSequenceValue(sequenceName);
      return response.data;
    },
    async getSequenceRoutings() {
      return await Api.Sequence.getSequenceRoutings();
    },
    async getSequenceLogs() {
      return await Api.Sequence.getSequenceLogs();
    },
    async createSequence(readableName, description = null) {
      return await Api.Sequence.createSequence(readableName, description);
    },
    async createSequenceRouting(seqName) {
      return await Api.Sequence.createSequenceRouting(seqName);
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSequenceStore, import.meta.hot));
}
